import { render, staticRenderFns } from "./CreateTenantsTab.vue?vue&type=template&id=4fef9971&scoped=true"
import script from "./CreateTenantsTab.vue?vue&type=script&lang=js"
export * from "./CreateTenantsTab.vue?vue&type=script&lang=js"
import style0 from "./CreateTenantsTab.vue?vue&type=style&index=0&id=4fef9971&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef9971",
  null
  
)

export default component.exports